// Global 401 Response Interceptor
// This will catch all 401 responses and force logout/login

import { logout } from './api';

// Store the original fetch
const originalFetch = window.fetch;

// Override fetch to add global 401 handling
window.fetch = async function(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  try {
    // Make the original request
    const response = await originalFetch(input, init);
    
    // Check for 401 status
    if (response.status === 401) {
      console.warn('401 Unauthorized response detected - forcing logout');
      
      // Clear all authentication data
      logout();
      
      // Throw an error to stop further processing
      throw new Error('Session expired. Please login again.');
    }
    
    return response;
  } catch (error) {
    // If it's already our 401 error, re-throw it
    if (error.message === 'Session expired. Please login again.') {
      throw error;
    }
    
    // For other errors, let them propagate normally
    throw error;
  }
};

// Export a function to initialize the interceptor (call this once in your app)
export const initializeGlobal401Interceptor = () => {
  console.log('Global 401 response interceptor initialized');
};
